module.exports = "/app/themes/roboyo2021/dist/img/location-wht.png?c26c82b065e1d595d4c86e7f1bae8ef0";